import { useCallback } from 'react';
import { uploadSignedAsset } from '../../api/misc';
import { PPSignedAssetResponse } from '../../api/Rover/partnerProposal';

export type SignAssetFn = (
  payload: any
) => Promise<PPSignedAssetResponse | any>;
export interface UseFileUploadInterface {
  signAsset: SignAssetFn;
}

export interface UploadPayload {
  signAssetPayload: any[];
  files: File[];
  field?: any;
}
export interface UploadFnReturn<T = File, S = PPSignedAssetResponse> {
  files: T[];
  sign: S | S[];
  response: any | any[];
}
export type UploadFn<T = File, S = any> = (
  payload: UploadPayload
) => Promise<UploadFnReturn<T, S>>;
export interface UseFileUploadReturnInterface {
  upload: UploadFn;
}
export const useFileUpload = (
  props: UseFileUploadInterface
): UseFileUploadReturnInterface => {
  const { signAsset } = props;
  const upload: UploadFn = useCallback(async (payload) => {
    const { signAssetPayload, files } = payload;
    const sign = await Promise.all(
      signAssetPayload.map((payload) => signAsset(payload))
    );
    const response = await Promise.all(
      sign.map(({ url }, index) =>
        uploadSignedAsset({ file: files[index], url })
      )
    );
    return {
      files,
      sign: signAssetPayload?.length === 1 ? sign[0] : sign,
      response: signAssetPayload?.length === 1 ? response[0] : response,
    };
  }, []);

  return {
    upload,
  };
};
